// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar.js';
import Footer from './components/Footer/Footer.js';
import Home from './pages/Home/Home.js';
import AutoPersonasPrivacy from './pages/privacy/AutoPersonasPrivacy.js';
import ClickCVPrivacy from './pages/privacy/ClickCVPrivacy.js';
import SpaceDSAPrivacy from './pages/privacy/SpaceDSAPrivacy.js';
import LayovraPrivacy from './pages/privacy/LayovraPrivacy.js';
import PromptGruupPrivacy from './pages/privacy/PromptGruupPrivacy.js';
import SubslockPrivacy from './pages/privacy/SubslockPrivacy.js';
import VariblyPrivacy from './pages/privacy/VariblyPrivacy.js';
import NutriScalePrivacy from './pages/privacy/NutriScalePrivacy.js';
import VeilPrivacy from './pages/privacy/VeilPrivacy.js';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy/autopersonas" element={<AutoPersonasPrivacy />} />
          <Route path="/privacy/clickcv" element={<ClickCVPrivacy />} />
          <Route path="/privacy/spacedsa" element={<SpaceDSAPrivacy />} />
          <Route path="/privacy/layovra" element={<LayovraPrivacy />} />
          <Route path="/privacy/promptgruup" element={<PromptGruupPrivacy />} />
          <Route path="/privacy/subslock" element={<SubslockPrivacy />} />
          <Route path="/privacy/varibly" element={<VariblyPrivacy />} />
          <Route path="/privacy/nutriscale" element={<NutriScalePrivacy />} />
          <Route path="/privacy/veil" element={<VeilPrivacy />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
